// https://gist.github.com/hengkiardo/3760884
export const formatMoney = (money: number) => {
    const minimumFractionDigits = 2
    const maximumFractionDigits = 2
    const result = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits,
        maximumFractionDigits,
    }).format(money)
    return result
}
